import $ from './el.JsModules.js';

const SELECTOR = {
  ITEM_TEMPLATE: '.el-you-may-also-like__item-template',
  ITEMS_CONTAINER: '.js-el-you-may-also-like-items',
};

elabs.YouMayAlsoLike = class {
  'use strict';
  constructor(element) {
    const {
      currencySymbol,
      currencyIsoCode,
      productIds,
      pageProductId,
      recommendationType,
      limit,
      showHandPickedProducts,
    } = $(element).data();
    this.view = $(element);
    this.itemTemplate = this.view.find(SELECTOR.ITEM_TEMPLATE)[0];
    this.itemsContainer = this.view.find(SELECTOR.ITEMS_CONTAINER);
    this.showHandPickedProducts = showHandPickedProducts;
    this.currencySymbol = currencySymbol;
    this.currencyIsoCode = currencyIsoCode;
    this.productIds = productIds;
    this.pageProductId = pageProductId;
    this.recommendationType = recommendationType;
    this.limit = limit;

    window.addEventListener('resize', () => this.handleResize());
  }

  initSlider() {
    this.swiperSlider = new Swiper(this.view.find('.swiper')[0], {
      slidesPerView: 'auto',
      speed: 700,
      spaceBetween: 10,
      observer: true,
      preventClicks: true,
      preventClicksPropagation: true,
      watchSlidesProgress: true,
      centeredSlides: true,
      loop: true,
      allowTouchMove: true,
      allowSlidePrev: true,
      allowSlideNext: true,
      on: {
        afterInit: (swiper) => this.updateAllowTouchMove(swiper),
        resize: (swiper) => this.updateAllowTouchMove(swiper),
        observerUpdate: (swiper) => this.updateAllowTouchMove(swiper),
        slideChangeTransitionEnd: (swiper) => this.updateAllowTouchMove(swiper),
      },
    });

    this.view.find('.el-circular-nav-button--prev, .el-slideshow__image-nav-left-button').click(() => {
      this.swiperSlider.slidePrev();
    });

    this.view.find('.el-circular-nav-button--next, .el-slideshow__image-nav-right-button').click(() => {
      this.swiperSlider.slideNext();
    });
  }

  updateAllowTouchMove(swiper) {
    const allVisible = this.checkAllSlidesVisible(swiper);

    swiper.allowTouchMove = !allVisible;
    swiper.allowSlidePrev = !allVisible;
    swiper.allowSlideNext = !allVisible;
    this.toggleButtonDisplay(allVisible);
  }

  checkAllSlidesVisible(swiper) {
    const originalSlides = Array.from(swiper.slides).filter(
      (slide) => !slide.classList.contains('swiper-slide-duplicate'),
    );
    return originalSlides.every((slide) => slide.classList.contains('swiper-slide-fully-visible'));
  }

  handleResize() {
    this.swiperSlider.destroy(true, true);
    this.initSlider();
  }

  toggleButtonDisplay(allVisible) {
    if (allVisible) {
      this.view.find('.el-circular-nav-button').hide();
      return;
    }

    this.view.find('.el-circular-nav-button').show();
  }

  async init() {
    if (this.recommendationType === 'hand-picked-products') {
      this.initSlider();
      return;
    }
    const excluded = ['15025435312472', '15025378558296', '15045679219032'];
    const API_URL = 'https://services.mybcapps.com/discovery/recommend';
    const payload = {
      shop: window.Shopify.shop || 'onedotworld.myshopify.com',
      recommendationType: this.recommendationType,
      productIds: this.productIds,
      debug: true,
      limit: this.limit,
      ruleBased: [
        {
          type: 'sameCollection',
          status: false,
          excluded,
        },
      ],
    };

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await res.json();
      let { products } = data;

      //API Note
      //"Currently, the API does not exclude the base products (productIds) from the returned list unless explicitly filtered."
      [...this.productIds, ...excluded].forEach((id) => {
        products = products.filter((item) => +id !== item.id);
      });

      for (const item of products) {
        if (item.id === this.pageProductId) continue;
        await this.renderItem(item);
      }

      this.initSlider();
    } catch (e) {
      console.error('Error with getting recommendations class YouMayAlsoLike:', e);
    }
  }

  async renderItem(item) {
    const currencyIsoCode = this.currencyIsoCode;

    let compareAtPrice = item[`compare_at_price_min_${currencyIsoCode}`] ?? item.compare_at_price_min;
    let price = item[`price_min_${currencyIsoCode}`] ?? item.price_min;
    const { images_info, title, handle, variants } = item;
    const image = images_info[0];
    const url = `/products/${handle}`;
    const productHasVariants = variants.length > 1;

    const $clone = $(this.itemTemplate.content.cloneNode(true));

    // LINK
    $clone.find('.js-product-link').attr('href', url);
    $clone.find('.js-text-wrapper').on('click', () => {
      window.location.href = url;
    });

    // IMAGE
    if (image) {
      $clone
        .find('.js-main-image')
        .attr('src', image.src)
        .attr('alt', image.alt || title)
        .removeClass('hidden');
    } else {
      $clone.find('.js-placeholder-image').removeClass('hidden');
    }

    // ACTIONS
    if (productHasVariants) {
      $clone.find('.js-recommendation-item-link').each(function () {
        $(this).attr('href', url).removeClass('hidden');
      });
    } else {
      $clone.find('.js-product-form').each(function () {
        $(this).find('form').attr('id', `product_form_${item.id}`);
        $(this).find('[name="id"]').val(variants[0].id);
        $(this).removeClass('hidden');
      });
    }

    // TITLE
    $clone.find('.js-title').text(title);

    // PRICE
    if (productHasVariants) {
      $clone.find('.js-price-product-with-variants .el-price__price').text(`from ${this.priceWithSymbol(price)}`);
      price && $clone.find('.js-price-product-with-variants').removeClass('hidden');
    } else {
      const $priceComponent = $clone.find('.js-price-product-with-one-variant');
      const $compareAtPriceEl = $priceComponent.find('.el-price__compare-at-price');
      const $defaultPriceEl = $priceComponent.find('.el-price__price');

      if (compareAtPrice) {
        $compareAtPriceEl.find('.compare_at_price').text(this.priceWithSymbol(compareAtPrice));
        $compareAtPriceEl.find('.el-price__discounted-price').text(this.priceWithSymbol(price));
        price && $compareAtPriceEl.removeClass('hidden');
      } else {
        price && $defaultPriceEl.text(this.priceWithSymbol(price)).removeClass('hidden');
      }
      price && $priceComponent.removeClass('hidden');
    }

    //B2B PRICE
    if (window.customer.is_trade_customer) {
      const data = await this.getB2Bprice(item.handle);
      $clone.find('.js-price-product-with-variants').addClass('hidden');
      $clone.find('.js-price-product-with-one-variant').addClass('hidden');

      $clone.find('.js-b2b-price').html(data.price_html).removeClass('hidden');
    }

    $(this.itemsContainer).append($clone);
  }

  async getB2Bprice(handle) {
    try {
      const res = await fetch(`/products/${handle}?view=boost-turbo-custom-integration`);
      const data = await res.json();
      return data;
    } catch (e) {
      console.log(`ERROR in: getB2Bprice`, e);
    }
  }

  priceWithSymbol(value) {
    const priceFormattedValue = Shopify.formatMoney(value * 100, '{{ amount_no_decimals }}');
    return `${this.currencySymbol}${priceFormattedValue}`;
  }

  duplicateSlidesUntilContainerFilled() {
    const $slides = this.view.find('.swiper-wrapper').children();
    const containerWidth = this.itemsContainer[0].offsetWidth;

    const firstSlide = $slides[0];
    if (!firstSlide) return;

    const slideWidth = firstSlide.offsetWidth;
    if (!slideWidth || containerWidth === 0) return;

    const minSlides = Math.ceil(containerWidth / slideWidth) + 1;
    const currentCount = $slides.length;

    if (currentCount >= minSlides) return;

    const fragment = document.createDocumentFragment();
    const slidesArray = Array.from($slides);

    let i = 0;
    while (slidesArray.length + fragment.childNodes.length < minSlides) {
      const clone = slidesArray[i % currentCount].cloneNode(true);
      fragment.appendChild(clone);
      i++;
    }

    this.itemsContainer[0].appendChild(fragment);
  }
};

// Initialise all Social Scrollers
async function initYouMayAlsoLike() {
  const elements = $('.el-you-may-also-like');
  for (let element of elements) {
    const instance = new elabs.YouMayAlsoLike(element);
    await instance.init();
  }
}

elabs.onJavascriptReady(function () {
  initYouMayAlsoLike();
});
